<template>
    <div class="card">
        <div class="card-body">
            <div class="text-center mb-3">
                <i class="icon-mail-read icon-2x text-slate-300 border-slate-300 border-3 rounded-round p-3 mb-3 mt-1"></i>
                <h5 class="mb-0">{{ $t('auth.registration.title') }}</h5>
                <span class="d-block text-muted">{{ $t('auth.registration.check_email_code_description') }}</span>
            </div>

            <p>{{ $t('auth.registration.check_email_code_message') }}<strong>{{ email }}</strong></p>

            <form @submit.prevent="checkCode">
                <FormGroup :label="$t('auth.fields.code')">
                    <Input type="number" :placeholder="$t('auth.fields.code')" v-model="codeValue"/>
                </FormGroup>

                <p style="margin-bottom: 0.75rem">
                    {{ $t('auth.registration.didnt_receive_code') }}
                    <span
                        :class="codeIsResent ? 'text-success' : 'text-primary'"
                        :style="{ cursor: codeIsResent ? 'default' : 'pointer' }"
                        @click="resendCode"
                    >
                        {{ codeIsResent ? $t('auth.registration.resent') : $t('auth.registration.resend') }}
                    </span>
                </p>

                <div style="display: flex">
                    <Button size="sm" @click="$emit('back')" color="secondary" class="mr-1" style="flex: 2">
                        <i class="icon-circle-left2 mr-2"></i>
                        {{ $t('auth.buttons.back') }}
                    </Button>
                    <Button size="sm" type="submit" color="primary" class="ml-1" style="flex: 3">
                        {{ $t('auth.buttons.confirm') }}
                        <i class="icon-circle-right2 ml-2"></i>
                    </Button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import FormGroup from "../../../../../components/new/form/group/FormGroup.vue";
import Input from "../../../../../components/new/form/Input.vue";
import Button from "../../../../../components/new/button/AppButton.vue";
import { httpClient } from "../../../../../services/HttpClient";
import MessageNotificator from "../../../../../services/MessageNotificator";

export default {
    name: "CheckEmailCodeCard",
    components: {
        FormGroup,
        Input,
        Button,
    },
    props: ['email', 'code'],
    emits: ['code-checked', 'back'],
    data() {
        return {
            codeValue: this.code,
            codeIsResent: false,
        }
    },
    methods: {
        async resendCode() {
            if (this.codeIsResent) {
                return;
            }

            await httpClient.post('/registration/send-email-code', {
                recipient_address: this.email,
            });

            new MessageNotificator().success(this.$t('auth.registration.send_email_code_success'));
            this.codeIsResent = true;
        },
        async checkCode() {
            await httpClient.post('/registration/check-email-code', {
                recipient_address: this.email,
                code: Number(this.codeValue),
            });

            new MessageNotificator().success(this.$t('auth.registration.check_email_code_success'));
            this.$emit('code-checked', this.codeValue);
        },
    },
}
</script>
